import { fetchListHotel, bookHotel, fetchServices, getMatrixHotels } from '@/api/service'

const updateListHotel = (context, payload) => {
  fetchListHotel(payload).then((response) => {
    const fetchedHotels = []

    const reservations = response?.reservation || []
    const listHotels = response?.list_hotel || []

    if (Array.isArray(reservations) && reservations.length > 0) {
      fetchedHotels.push(...reservations)
    }

    if (Array.isArray(listHotels) && listHotels.length > 0) {
      fetchedHotels.push(...listHotels)
    }

    context.commit('DATA_LIST_HOTEL_UPDATED', fetchedHotels)
  })
}

const fetchMatrixHotels = (context, payload) => {
  return getMatrixHotels(payload).then((response) => {
    return response
  })
}

const bookListHotel = async (context, payload) => {
  return bookHotel(payload).then((response) => {
    return response
  })
}

const getServices = (context) => {
  return fetchServices().then((response) => {
    context.commit('SERVICES_UPDATED', _.keyBy(response, 'service_id'))
    return context.state.services
  })
}

export default {
  updateListHotel,
  bookListHotel,
  getServices,
  fetchMatrixHotels
}
